import {
  fieldSeparatorDroppableIdRegex,
  groupSeparatorDroppableIdRegex,
} from "../constants";

export const isFieldSeparatorId = (droppableId: string): boolean =>
  !!droppableId.match(fieldSeparatorDroppableIdRegex);

export const isGroupSeparatorId = (droppableId: string): boolean =>
  !!droppableId.match(groupSeparatorDroppableIdRegex);

export const extractDroppableFieldPosition = (droppableId: string): number => {
  if (!isFieldSeparatorId(droppableId) && !isGroupSeparatorId(droppableId))
    return -1;

  const parts = droppableId.split("|");
  return parseInt(parts[parts.length - 1], 10);
};
